import { render, staticRenderFns } from "./BSignUpPasswordStep.vue?vue&type=template&id=32e1832f&"
import script from "./BSignUpPasswordStep.vue?vue&type=script&lang=ts&"
export * from "./BSignUpPasswordStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports